module.exports = __webpack_public_path__ + "media/images/hitfun/icon.prize.consolation-807688068d27035ec31791a2f747ec0c.svg";